export default  {
  bindings: {
    property: '=',
    title: '@'
  },
  controller: 'propertySaveController',
  template: require('../views/property.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.save.component.js